export const carPickerAnalyticsEvent = (name, data = {}) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger(`car-picker.${name}`, data);
  }
};